import React from "react";
import { Button, View, Text } from "react-native";
import ManaBtn from "../components/ManaBtn";

class PageError {
  constructor(props) {
    this.controller = props.controller;
  }

  render() {
    const onRetry = this.onRetry.bind(this);
    const hasMessage =
      this.controller.state != null &&
      this.controller.state.screenArgs != null &&
      this.controller.state.screenArgs.message != null;
    const message = hasMessage
      ? this.controller.state.screenArgs.message
      : null;

    return (
      <View style={{ alignItems: "center", justifyContent: "center", flex: 1 }}>
        <Text>{"Error"}</Text>
        {hasMessage ? <Text>{message}</Text> : null}
        <Text> </Text>
        <ManaBtn onPress={onRetry} title="Retry" />
      </View>
    );
  }

  onRetry() {
    this.controller.resetState(true);
    this.controller.getItems();
  }
}

export default PageError;
